module.exports = __webpack_public_path__ + "static/Banane-4b78c7a66e0c67dc38d5ff64812f5b83.png";